import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import superAdminServices from "../api/services/superAdminService.js";
import { handleApiError } from "../utils/apiHelpers.js";

export const addAdminUser = createAsyncThunk(
  "superAdmin/add-admin",
  async (data, thunkAPI) => {
    try {
      const response = await superAdminServices.addAdmin(data);
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteAdminUser = createAsyncThunk(
  "superAdmin/delete-admin",
  async (data, thunkAPI) => {
    try {
      const response = await superAdminServices.deleteAdmin(data);
      if (response && response.data) {
        return response.data;
      }
      throw new Error("No data found");
    } catch (error) {
      handleApiError(error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const superAdminSlice = createSlice({
  name: "add-admin",
  initialState: {
    name: "",
    email: "",
    password: "",
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAdminUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAdminUser.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.name = action.payload.name;
        state.email = action.payload.email;
        state.password = action.payload.password;
      })
      .addCase(addAdminUser.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(deleteAdminUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdminUser.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.name = action.payload.name;
        state.email = action.payload.email;
        state.password = action.payload.password;
      })
      .addCase(deleteAdminUser.rejected, (state, action) => {
        state.error = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default superAdminSlice.reducer;
